export const SWIPERDATA = {
  services: [
    {
      title: "consulting",
      image: "/service-consulting.png",
      description:
        "We help global business leaders and organizations with our comprehensively improving consulting services such as business consulting, IT consulting and risk consulting.",
      url: "/consulting",
    },
    {
      title: "SOCaaS",
      image: "/socaas.png",
      description:
        "Advanced, cost-effective security monitoring for startups and mid-sized businesses in Saudi Arabia. Ensure compliance with SAMA & NCA regulations, 24/7 threat detection, and local Arabic-speaking experts—all without the overhead of an in-house SOC.",
      url: "/socaas",
    },
    {
      title: "cybersecurity",
      image: "/service-cybersecurity.png",
      description:
        "We have a professional cybersecurity and service team, fully integrating industry-leading core technologies and products to provide customers with a full range of network security solutions.",
      url: "/cybersecurity",
    },

    {
      title: "cybersecurity awareness",
      image: "/service-cybersecurity-awareness.png",
      description:
        "CyberStone will provide instructor to deliver security awareness session that will aim at reducing the risk associated with the information systems by increasing the awareness of user community in the following topics",
      url: "/cybersecurity-awareness",
    },
    {
      title: "Operational Technology",
      image: "/service-ot.png",
      description:
        "CyberStone OT security protects critical industrial systems by offering specialized monitoring, threat detection, and incident response, ensuring the safety and continuity of operations in energy grids and manufacturing plants.",
      url: "/ot-security",
    },
  ],
}
